import { get } from 'lodash-es';

import { getSortedEntries } from '../layout';

type EntityWithSections = {
  sections: Array<{
    id: string;
    layout?: string[];
    blocks: { id: string }[];
  }>;
};

/** Get all blocks ordered exactly how they appear in the document, from top to bottom **/
const getEntitySortedBlocks = <T extends EntityWithSections>(entity: T, isEndorsementSummary = false) => {
  const accessorPrefix = isEndorsementSummary ? 'summary.' : '';

  const sections = get(entity, `${accessorPrefix}sections`, []) as T['sections'];
  const layout = get(entity, `${accessorPrefix}layout`, []) as string[];

  const sortedSections = getSortedEntries(layout, sections);
  return sortedSections.flatMap((section) => getSortedEntries(section.layout ?? [], section.blocks));
};

export const getAllBlocks = <T extends EntityWithSections>(
  entity?: T,
  isEndorsementView: boolean = false,
): T['sections'][number]['blocks'] => {
  if (!entity) {
    return [];
  }

  return getEntitySortedBlocks(entity, isEndorsementView);
};
